module.exports = __webpack_public_path__ + "img/slide4.4cd9e943.png";